import client from "./client";

const queryGameConsume = (type: 1 | 3 | 4) =>
    client.post("/queryGameConsume", {
        "X-Token": "",
        type,
    });

const getUserGameRecordsList = (page: number, pageSize: number, type: 0 | 1, gameId: number) =>
    client.post("/getUserGameRecordsList", {
        pageId: page,
        pageCount: pageSize,
        gameId,
        type,
    });

const getWagerContestData = (tokenId: number) => client.post("/getWagerContestData", {tokenId});

const apiGameHistory = {
    getUserGameRecordsList,
    queryGameConsume,
    getWagerContestData,
};

export default apiGameHistory;
